<template>
  <div class="employeeSkillsetDetails.vue">

    <!-- Tab content area -->
    <div class="c-common-space c-responsive-fixwidth c-common-box-shadow c-radius3">
        <div class="c-user-tab-content clearfix o-skillset-area">
            <div v-for="(skill,index) in skills" :key="index" class="col-md-3 table-td-border-right">
                <ul class="c-skillset">
                    <li><span>{{skill.name}} {{ getSkillSeniority(skill.id) ? '('+getSkillSeniority(skill.id)+')' : ''}}</span> <i class="fa fa-star"></i></li>
                </ul>                        
            </div>
        </div>
    </div>
    <!-- /Tab content area -->
  </div>
</template>
<script>
import service from '../../services';
export default
{
  data()
  {
    return {
      skills:[],
      skill_seniorities: []
    }
  },
  props: {
      empDetails: {
          type: Object,
          required: true
      }
  },
  watch: {
      empDetails: function(newData) {
          //console.log(newData);
          this.skills= newData.skills; 
          this.skill_seniorities = newData.skill_seniority;            
      }
  },
  methods: {
    getSkillSeniority(id) {
        let index = this.skill_seniorities.findIndex((item) => item.skill_id === id )
        if(index !== -1) {
            return this.skill_seniorities[index].seniority
        }
    }
  },
  beforeMount()
  {   
     this.skills = this.empDetails.skills;
     this.skill_seniorities = this.empDetails.skill_seniority;
     //console.log(this.skills);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employees/employeeSkills.vue